import { css, StyleSheet } from 'aphrodite'
import React from 'react'
import cn from 'classnames'

export default function Button({ text, onClick, loading, className, icon, type = 'button', ...rest }) {
    return (
        <button
            onClick={onClick}
            type={type}
            className={cn('button', className, { 'is-loading': loading, [css(styles.button)]: true })}
            {...rest}
        >
            {icon && (
                <span className={css(styles.iconWrapper)}>
                    <ion-icon name={icon} className={css(styles.icon)} />
                </span>
            )}
            {text}
        </button>
    )
}

const styles = StyleSheet.create({
    button: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '0.5rem', // Icon va matn orasidagi masofa
        padding: '0.6rem 1rem',
        fontSize: '1rem',
        fontWeight: '600',
        borderRadius: '6px',
        transition: 'background 0.3s ease, transform 0.2s ease',
    },
    iconWrapper: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    icon: {
        fontSize: '1.2rem',
        color: 'inherit',
    }
})
